import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { NgxEchartsModule } from 'ngx-echarts';
import { AssessmentReportModule } from '@app/main/analytics/assessment/assessment-report/assessment-report.module';
import { RouterModule } from '@angular/router';
import { LearnerReportComponent } from './learner-report/learner-report.component';
import { ProgramIndexComponent } from './program-index/program-index.component';

const routes = [
  {
    path: 'player-view/courses/:courseId/sessions/:sessionId/report',
    component: LearnerReportComponent,
    data: { hideTopBar: true }
  },
  {
    path: 'player-view/courses/:courseId/index',
    component: ProgramIndexComponent,
    data: { hideTopBar: true }
  }
];

@NgModule({
  declarations: [
    LearnerReportComponent,
    ProgramIndexComponent
  ],
  imports: [
    AssessmentReportModule,
    SharedModule,
    CommonModule,
    RouterModule.forRoot(routes),
    NgxEchartsModule.forChild(),
  ],
  exports: [
    LearnerReportComponent,
    ProgramIndexComponent
  ]
})
export class PlayerViewModule { }
